import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of, forkJoin, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class SetupGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.getUserDetails().pipe(
      switchMap(user => {
        const hasName = !!(user && typeof user.name === 'string' && user.name.trim().length > 0);
        if (!hasName) {
          return of(this.router.parseUrl('/user-setup'));
        }
        return forkJoin([
          from(this.auth.getSelectedAccountId()),
          this.auth.getCurrentAccounts()
        ]).pipe(
          switchMap(async ([selectedAccountId, accounts]) => {
            if (selectedAccountId) {
              return true;
            }
            const hasAny = Array.isArray(accounts) && accounts.length > 0;
            if (!hasAny) {
              return this.router.parseUrl('/account-wizard');
            }
            // Has accounts but none selected: select the first and continue
            try { await this.auth.setSelectedAccount(String(accounts[0].id)); } catch {}
            return true;
          })
        );
      }),
      catchError(() => of(this.router.parseUrl('/account-wizard')))
    );
  }
}


